import styles from './AlgoWalletsList.module.scss';

import { type Wallet, useWallet } from '@txnlab/use-wallet-react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { Loader } from '../../../../components';

export const AlgoWalletsList = observer(() => {
  const { wallets, activeWallet } = useWallet();

  return (
    <div className={styles.algoWallets}>
      <div className={styles.algoWalletsTitle}>Connect Wallet</div>
      <div className={styles.walletOptions}>
        {wallets.map((wallet) => (
          <WalletOption
            key={wallet.id}
            wallet={wallet}
            activeWallet={activeWallet}
          />
        ))}
      </div>
    </div>
  );
});

const WalletOption = ({ wallet }: { wallet: Wallet; activeWallet?: any }) => {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = async () => {
    setConnecting(true);

    // Reset connecting state after 10 seconds regardless of outcome
    setTimeout(() => {
      setConnecting(false);
    }, 10000);

    try {
      await wallet.connect();
    } catch (error) {
      console.error('Failed to connect:', error);

      if (error instanceof Error && error.message.includes('accounts')) {
        console.warn(
          'WalletConnect: Connected wallet does not support Algorand. Please use an Algorand-compatible wallet.',
        );
      }
    } finally {
      setConnecting(false);
    }
  };

  return (
    <>
      {connecting && (
        <Loader
          screenStyles={{
            height: '100%',
            position: 'absolute',
            background: 'none',
          }}
        />
      )}
      <button
        onClick={handleConnect}
        disabled={connecting}
        className={styles.walletOption}
        style={{ opacity: connecting ? 0.3 : 1 }}
      >
        <img
          src={wallet.metadata.icon}
          alt={wallet.metadata.name}
          width={32}
          height={32}
        />
        <span>{wallet.metadata.name}</span>
      </button>
    </>
  );
};
